import React from 'react'
import Home from '../components/home/Home.tsx'

const HomePage = () => {
    return (
        <div >
            <Home />
        </div>
    )
}

export default HomePage